module.exports = __webpack_public_path__ + "static/media/Menu.37343bd7.svg";